<template>
  <div>
    <v-row>
      <v-col>
        <div class="text-h4 font-weight-bold my-2 text-darkblue">Actions réservées à Sportips</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pa-2">
        <div class="pa-1">
          <div class="d-flex flex-wrap gap">
            <v-card class="bg-grey_1">
              <template v-slot:title> Rechercher globale</template>
              <template v-slot:subtitle>Sur tous les modules</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'ExplorerSuperAdmin' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Explorer</v-btn>
                </router-link>
              </template>
            </v-card>

            <v-card class="bg-grey_1">
              <template v-slot:title> Exporter la liste des inscrits</template>
              <template v-slot:subtitle>au format EXCEL</template>
              <template v-slot:actions>
                <ButtonExportsSportips></ButtonExportsSportips>
              </template>
            </v-card>

            <v-card class="bg-grey_1">
              <template v-slot:title> Envoyer l'email récapitulatif</template>
              <template v-slot:subtitle>à tous les participants</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'EnvoiRecapEmail' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Ouvrir</v-btn>
                </router-link>
              </template>
            </v-card>
            <v-card class="bg-grey_1">
              <template v-slot:title> Envoyer l'email de rappel de doc</template>
              <template v-slot:subtitle>à tous les participants non validés</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'EnvoiRappelDocEmail' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Ouvrir</v-btn>
                </router-link>
              </template>
            </v-card>

            <v-card class="bg-grey_1" v-if="mainStore.module.has_alerte_sms">
              <template v-slot:title> Envoyer l'email de rappel de contact SMS</template>
              <template v-slot:subtitle>aux participants ayant souscrit à l'alerte SMS</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'EnvoiRappelContactSMS' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Ouvrir</v-btn>
                </router-link>
              </template>
            </v-card>
            <v-card class="bg-grey_1" v-if="mainStore.module.need_gestion_equipe">
              <template v-slot:title> Gestion des équipes</template>
              <template v-slot:subtitle>nom d’équipe, inscriptions et commandes</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'GestionEquipesAdmin' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Ouvrir</v-btn>
                </router-link>
              </template>
            </v-card>

            <v-card class="bg-grey_1">
              <template v-slot:title> Gérer les accès</template>
              <template v-slot:subtitle>de ce module</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'GestionAcces' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Gérer</v-btn>
                </router-link>
              </template>
            </v-card>
            <v-card class="bg-grey_1">
              <template v-slot:title> Demandes de paiement</template>
              <template v-slot:subtitle>de ce module</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'PaymentsRequests' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>

            <v-card class="bg-grey_1" v-if="mainStore.authAdmin.hasSuperAdminRights">
              <template v-slot:title> Lien d'inscription </template>
              <template v-slot:subtitle>privilégié multi-usage</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'LienMultiVIP' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>
            <!--  <v-card class="bg-grey_1" v-if="mainStore.authAdmin.hasSuperAdminRights">
              <template v-slot:title>Campagne d'emails automatisées</template>
              <template v-slot:subtitle>Consulter et créer</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'MailingSystem' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card> -->
            <v-card class="bg-grey_1" v-if="mainStore.authAdmin.hasSuperAdminRights">
              <template v-slot:title> Remboursements en masse </template>
              <template v-slot:subtitle>des participants</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'BulkRefunds' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>


          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import ButtonExportsSportips from "./ButtonExportsSportips.vue";
export default {
  components: { ButtonExportsSportips },
  data() {
    return {
      base_url: process.env.VUE_APP_API_BASE,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped></style>